Number.prototype.formatMoney = function(c, d, t){
    var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substring(0, j) + t : "") + i.substring(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};



calculate = function calculate() {
    //In-Parameter
    var allIn = 0;

    var inEinnahmen = document.getElementById("in_einnahmen").value;
    inEinnahmen = parseInt(inEinnahmen.replace(".",""));
    var inEinnahmenSelect = parseInt(document.getElementById("in_einnahmen_select").value);
    if(isNaN(inEinnahmen) === true) inEinnahmen = 0;
    var inEinnahmenPerMonth = inEinnahmen/inEinnahmenSelect;

    var inZuschuss = document.getElementById("in_zuschuesse").value;
    inZuschuss = parseInt(inZuschuss.replace(".",""));
    var inZuschussSelect = parseInt(document.getElementById("in_zuschuesse_select").value);
    if(isNaN(inZuschuss) === true) inZuschuss = 0;
    var inZuschussPerMonth = inZuschuss/inZuschussSelect;

    var inSonstige = document.getElementById("in_sonstigeeinnahmen").value;
    inSonstige = parseInt(inSonstige.replace(".",""));
    var inSonstigeSelect = parseInt(document.getElementById("in_sonstigeeinnahmen_select").value);
    if(isNaN(inSonstige) === true) inSonstige = 0;
    var inSonstigePerMonth = inSonstige/inSonstigeSelect;
    
    var allIn = parseInt(inEinnahmenPerMonth + inZuschussPerMonth + inSonstigePerMonth);

    //Out-Parameter-----------------------------
    var allOut = 0;
    var allOutNew = 0;
    var outNewStatus = 0;

    //--Wohnen: Miete------*/
    var outMiete = 0;
    var outMieteNew = 0;
    var outMietePerMonth = 0;
    var outMietePerMonthNew = 0;
    if(document.getElementById("out_miete").value != ""){
        var outMiete = document.getElementById("out_miete").value;
        outMiete =  parseInt(outMiete.replace(".",""));
        if(document.body.contains(document.getElementById("out_wohnen_slider")) && document.getElementById("out_wohnen_slider").value > 0){
            document.getElementById("out_miete_new").style.display = 'block';
            var sliderValue = document.getElementById("out_wohnen_slider").value;
            outMieteNew = parseInt(outMiete + (sliderValue * outMiete/100));
            outNewStatus = 1;
        } else document.getElementById("out_miete_new").style.display = 'none';
        var outMieteSelect = parseInt(document.getElementById("out_miete_select").value);
        outMietePerMonth = parseInt(outMiete/outMieteSelect);
        outMietePerMonthNew = parseInt(outMieteNew/outMieteSelect);
        document.getElementById("out_miete_new").innerHTML = (outMieteNew).formatMoney(2, ',', '.');
        if(outMietePerMonthNew == 0) outMietePerMonthNew = outMietePerMonth; 
    } 
    //--Wohnen: sonst. Wohnen------*/
    var outWohnenSonstige = 0;
    var outWohnenSonstigeNew = 0;
    var outWohnenSonstigePerMonth = 0;
    var outWohnenSonstigePerMonthNew = 0;
    if(document.getElementById("out_sonst_wohnkosten").value != ""){
        var outWohnenSonstige = document.getElementById("out_sonst_wohnkosten").value;
        outWohnenSonstige =  parseInt(outWohnenSonstige.replace(".",""));
        if(document.body.contains(document.getElementById("out_wohnen_slider")) && document.getElementById("out_wohnen_slider").value > 0){
            document.getElementById("out_sonst_wohnkosten_new").style.display = 'block';
            var sliderValue = document.getElementById("out_wohnen_slider").value;
            outWohnenSonstigeNew = parseInt(outWohnenSonstige + (sliderValue * outWohnenSonstige/100));
            outNewStatus = 1;
        } else document.getElementById("out_sonst_wohnkosten_new").style.display = 'none';
        var outWohnenSonstigeSelect = parseInt(document.getElementById("out_sonst_wohnkosten_select").value);
        outWohnenSonstigePerMonth = parseInt(outWohnenSonstige/outWohnenSonstigeSelect);
        outWohnenSonstigePerMonthNew = parseInt(outWohnenSonstigeNew/outWohnenSonstigeSelect);
        document.getElementById("out_sonst_wohnkosten_new").innerHTML = (outWohnenSonstigeNew).formatMoney(2, ',', '.');
        if(outWohnenSonstigePerMonthNew == 0) outWohnenSonstigePerMonthNew = outWohnenSonstigePerMonth; 
    } 
    //--Wohnen: Strom------*/
    var outStrom = 0;
    var outStromNew = 0;
    var outStromPerMonth = 0;
    var outStromPerMonthNew = 0;
    if(document.getElementById("out_strom").value != ""){
        var outStrom = document.getElementById("out_strom").value;
        outStrom =  parseInt(outStrom.replace(".",""));
        if(document.body.contains(document.getElementById("out_strom_slider")) && document.getElementById("out_strom_slider").value > 0){
            document.getElementById("out_strom_new").style.display = 'block';
            var sliderValue = document.getElementById("out_strom_slider").value;
            //outStromNew = parseInt(outStrom + (sliderValue * outStrom/100));
            outStromNew = parseInt(sliderValue * outStrom);
            outNewStatus = 1;
        } else document.getElementById("out_strom_new").style.display = 'none';
        var outStromSelect = parseInt(document.getElementById("out_strom_select").value);
        outStromPerMonth = parseInt(outStrom/outStromSelect);
        outStromPerMonthNew = parseInt(outStromNew/outStromSelect);
        document.getElementById("out_strom_new").innerHTML = (outStromNew).formatMoney(2, ',', '.');
        if(outStromPerMonthNew == 0) outStromPerMonthNew = outStromPerMonth; 
    } 
    //--Wohnen: Wärme------*/
    var outWaerme = 0;
    var outWaermeNew = 0;
    var outWaermePerMonth = 0;
    var outWaermePerMonthNew = 0;
    if(document.getElementById("out_waerme").value != ""){
        var outWaerme = document.getElementById("out_waerme").value;
        outWaerme =  parseInt(outWaerme.replace(".",""));
        if(document.body.contains(document.getElementById("out_waerme_slider")) && document.getElementById("out_waerme_slider").value > 0){
            document.getElementById("out_waerme_new").style.display = 'block';
            var sliderValue = document.getElementById("out_waerme_slider").value;
            outWaermeNew = parseInt(sliderValue * outWaerme);
            //outWaermeNew = parseInt(outWaerme + (sliderValue * outWaerme/100));
            outNewStatus = 1;
        } else document.getElementById("out_waerme_new").style.display = 'none';
        var outWaermeSelect = parseInt(document.getElementById("out_waerme_select").value);
        outWaermePerMonth = parseInt(outWaerme/outWaermeSelect);
        outWaermePerMonthNew = parseInt(outWaermeNew/outWaermeSelect);
        document.getElementById("out_waerme_new").innerHTML = (outWaermeNew).formatMoney(2, ',', '.');
        if(outWaermePerMonthNew == 0) outWaermePerMonthNew = outWaermePerMonth; 
    } 

    //--Leben: Einkäufe-------*/
    var outEinkauf = 0;
    var outEinkaufNew = 0;
    var outEinkaufPerMonth = 0;
    var outEinkaufPerMonthNew = 0;
    if(document.getElementById("out_leben_einkauf").value != ""){
        var outEinkauf = document.getElementById("out_leben_einkauf").value;
        outEinkauf =  parseInt(outEinkauf.replace(".",""));
        if(document.body.contains(document.getElementById("out_leben_slider")) && document.getElementById("out_leben_slider").value > 0){
            document.getElementById("out_leben_einkauf_new").style.display = 'block';
            var sliderValue = document.getElementById("out_leben_slider").value;
            outEinkaufNew = parseInt(outEinkauf + (sliderValue * outEinkauf/100));
            outNewStatus = 1;
        } else document.getElementById("out_leben_einkauf_new").style.display = 'none';
        var outEinkaufSelect = parseInt(document.getElementById("out_leben_einkauf_select").value);
        outEinkaufPerMonth = parseInt(outEinkauf/outEinkaufSelect);
        outEinkaufPerMonthNew = parseInt(outEinkaufNew/outEinkaufSelect);
        document.getElementById("out_leben_einkauf_new").innerHTML = (outEinkaufNew).formatMoney(2, ',', '.');
        if(outEinkaufPerMonthNew == 0) outEinkaufPerMonthNew = outEinkaufPerMonth; 
    }

    //--Leben: Kleidung-------*/
    var outKleidung = 0;
    var outKleidungNew = 0;
    var outKleidungPerMonth = 0;
    var outKleidungPerMonthNew = 0;
    if(document.getElementById("out_leben_kleidung").value != ""){
        outKleidung = document.getElementById("out_leben_kleidung").value;
        outKleidung =  parseInt(outKleidung.replace(".",""));
        if(document.body.contains(document.getElementById("out_leben_slider")) && document.getElementById("out_leben_slider").value > 0){
            document.getElementById("out_leben_kleidung_new").style.display = 'block';
            var sliderValue = document.getElementById("out_leben_slider").value;
            outKleidungNew = parseInt(outKleidung + (sliderValue * outKleidung/100));
            outNewStatus = 1;
        } else document.getElementById("out_leben_kleidung_new").style.display = 'none';
        var outKleidungSelect = parseInt(document.getElementById("out_leben_kleidung_select").value);
        outKleidungPerMonth = parseInt(outKleidung/outKleidungSelect);
        outKleidungPerMonthNew = parseInt(outKleidungNew/outKleidungSelect);
        document.getElementById("out_leben_kleidung_new").innerHTML = (outKleidungNew).formatMoney(2, ',', '.');
        if(outKleidungPerMonthNew == 0) outKleidungPerMonthNew = outKleidungPerMonth; 
    } 

    //--Leben: Internet und Telekommunikation-------*/
    var outInternetTele = 0;
    var outInternetTeleNew = 0;
    var outInternetTelePerMonth = 0;
    var outInternetTelePerMonthNew = 0;
    if(document.getElementById("out_internet_tele").value != ""){
        outInternetTele = document.getElementById("out_internet_tele").value;
        outInternetTele =  parseInt(outInternetTele.replace(".",""));
        if(document.body.contains(document.getElementById("out_leben_slider")) && document.getElementById("out_leben_slider").value > 0){
            document.getElementById("out_internet_tele_new").style.display = 'block';
            var sliderValue = document.getElementById("out_leben_slider").value;
            outInternetTeleNew = parseInt(outInternetTele + (sliderValue * outInternetTele/100));
            outNewStatus = 1;
        } else document.getElementById("out_internet_tele_new").style.display = 'none';
        var outInternetTeleSelect = parseInt(document.getElementById("out_internet_tele_select").value);
        outInternetTelePerMonth = parseInt(outInternetTele/outInternetTeleSelect);
        outInternetTelePerMonthNew = parseInt(outInternetTeleNew/outInternetTeleSelect);
        document.getElementById("out_internet_tele_new").innerHTML = (outInternetTeleNew).formatMoney(2, ',', '.');
        if(outInternetTelePerMonthNew == 0) outInternetTelePerMonthNew = outInternetTelePerMonth; 
    } 

    //--Leben: Medien und Streaming-------*/
    var outMedienStreaming = 0;
    var outMedienStreamingNew = 0;
    var outMedienStreamingPerMonth = 0;
    var outMedienStreamingPerMonthNew = 0;
    if(document.getElementById("out_medien_streaming").value != ""){
        outMedienStreaming = document.getElementById("out_medien_streaming").value;
        outMedienStreaming =  parseInt(outMedienStreaming.replace(".",""));
        if(document.body.contains(document.getElementById("out_leben_slider")) && document.getElementById("out_leben_slider").value > 0){
            document.getElementById("out_medien_streaming_new").style.display = 'block';
            var sliderValue = document.getElementById("out_leben_slider").value;
            outMedienStreamingNew = parseInt(outMedienStreaming + (sliderValue * outMedienStreaming/100));
            outNewStatus = 1;
        } else document.getElementById("out_medien_streaming_new").style.display = 'none';
        var outMedienStreamingSelect = parseInt(document.getElementById("out_medien_streaming_select").value);
        outMedienStreamingPerMonth = parseInt(outMedienStreaming/outMedienStreamingSelect);
        outMedienStreamingPerMonthNew = parseInt(outMedienStreamingNew/outMedienStreamingSelect);
        document.getElementById("out_medien_streaming_new").innerHTML = (outMedienStreamingNew).formatMoney(2, ',', '.');
        if(outMedienStreamingPerMonthNew == 0) outMedienStreamingPerMonthNew = outMedienStreamingPerMonth; 
    } 
   
    //--Leben: Gesundheit-------*/
    var outGesundheit = 0;
    var outGesundheitNew = 0;
    var outGesundheitPerMonth = 0;
    var outGesundheitPerMonthNew = 0;
    if(document.getElementById("out_gesundheit").value != ""){
        outGesundheit = document.getElementById("out_gesundheit").value;
        outGesundheit =  parseInt(outGesundheit.replace(".",""));
        if(document.body.contains(document.getElementById("out_leben_slider")) && document.getElementById("out_leben_slider").value > 0){
            document.getElementById("out_gesundheit_new").style.display = 'block';
            var sliderValue = document.getElementById("out_leben_slider").value;
            outGesundheitNew = parseInt(outGesundheit + (sliderValue * outGesundheit/100));
            outNewStatus = 1;
        } else document.getElementById("out_gesundheit_new").style.display = 'none';
        var outGesundheitSelect = parseInt(document.getElementById("out_gesundheit_select").value);
        outGesundheitPerMonth = parseInt(outGesundheit/outGesundheitSelect);
        outGesundheitPerMonthNew = parseInt(outGesundheitNew/outGesundheitSelect);
        document.getElementById("out_gesundheit_new").innerHTML = (outGesundheitNew).formatMoney(2, ',', '.');
        if(outGesundheitPerMonthNew == 0) outGesundheitPerMonthNew = outGesundheitPerMonth; 
    } 

    //--Leben: Versicherungen-------*/
    var outVersicherungen = 0;
    var outVersicherungenNew = 0;
    var outVersicherungenPerMonth = 0;
    var outVersicherungenPerMonthNew = 0;
    if(document.getElementById("out_versicherungen").value != ""){
        outVersicherungen = document.getElementById("out_versicherungen").value;
        outVersicherungen =  parseInt(outVersicherungen.replace(".",""));
        if(document.body.contains(document.getElementById("out_leben_slider")) && document.getElementById("out_leben_slider").value > 0){
            document.getElementById("out_versicherungen_new").style.display = 'block';
            var sliderValue = document.getElementById("out_leben_slider").value;
            outVersicherungenNew = parseInt(outVersicherungen + (sliderValue * outVersicherungen/100));
            outNewStatus = 1;
        } else document.getElementById("out_versicherungen_new").style.display = 'none';
        var outVersicherungenSelect = parseInt(document.getElementById("out_versicherungen_select").value);
        outVersicherungenPerMonth = parseInt(outVersicherungen/outVersicherungenSelect);
        outVersicherungenPerMonthNew = parseInt(outVersicherungenNew/outVersicherungenSelect);
        document.getElementById("out_versicherungen_new").innerHTML = (outVersicherungenNew).formatMoney(2, ',', '.');
        if(outVersicherungenPerMonthNew == 0) outVersicherungenPerMonthNew = outVersicherungenPerMonth; 
    } 



    //--Mobilität: Fahrzeuge-------*/
    var outFahrzeuge = 0;
    var outFahrzeugeNew = 0;
    var outFahrzeugePerMonth = 0;
    var outFahrzeugePerMonthNew = 0;
    if(document.getElementById("out_mobi_fahrzeuge").value != ""){
        outFahrzeuge = document.getElementById("out_mobi_fahrzeuge").value;
        outFahrzeuge =  parseInt(outFahrzeuge.replace(".",""));
        if(document.body.contains(document.getElementById("out_mobilitaet_slider")) && document.getElementById("out_mobilitaet_slider").value > 0){
            document.getElementById("out_mobi_fahrzeuge_new").style.display = 'block';
            var sliderValue = document.getElementById("out_mobilitaet_slider").value;
            outFahrzeugeNew = parseInt(outFahrzeuge + (sliderValue * outFahrzeuge/100));
            outNewStatus = 1;
        } else document.getElementById("out_mobi_fahrzeuge_new").style.display = 'none';
        var outFahrzeugeSelect = parseInt(document.getElementById("out_mobi_fahrzeuge_select").value);
        outFahrzeugePerMonth = parseInt(outFahrzeuge/outFahrzeugeSelect);
        outFahrzeugePerMonthNew = parseInt(outFahrzeugeNew/outFahrzeugeSelect);
        document.getElementById("out_mobi_fahrzeuge_new").innerHTML = (outFahrzeugeNew).formatMoney(2, ',', '.');
        if(outFahrzeugePerMonthNew == 0) outFahrzeugePerMonthNew = outFahrzeugePerMonth; 
    } 
    //--Mobilität: ÖPNV-------*/
    var outOpnv = 0;
    var outOpnvNew = 0;
    var outOpnvPerMonth = 0;
    var outOpnvPerMonthNew = 0;
    if(document.getElementById("out_mobi_opnv").value != ""){
        outOpnv = document.getElementById("out_mobi_opnv").value;
        outOpnv =  parseInt(outOpnv.replace(".",""));
        if(document.body.contains(document.getElementById("out_mobilitaet_slider")) && document.getElementById("out_mobilitaet_slider").value > 0){
            document.getElementById("out_mobi_opnv_new").style.display = 'block';
            var sliderValue = document.getElementById("out_mobilitaet_slider").value;
            outOpnvNew = parseInt(outOpnv + (sliderValue * outOpnv/100));
            outNewStatus = 1;
        } else document.getElementById("out_mobi_opnv_new").style.display = 'none';
        var outOpnvSelect = parseInt(document.getElementById("out_mobi_opnv_select").value);
        outOpnvPerMonth = parseInt(outOpnv/outOpnvSelect);
        outOpnvPerMonthNew = parseInt(outOpnvNew/outOpnvSelect);
        document.getElementById("out_mobi_opnv_new").innerHTML = (outOpnvNew).formatMoney(2, ',', '.');
        if(outOpnvPerMonthNew == 0) outOpnvPerMonthNew = outOpnvPerMonth; 
    } 
    //--Mobilität: Sonstige-------*/
    var outMobilitaetSonstige = 0;
    var outMobilitaetSonstigeNew = 0;
    var outMobilitaetSonstigePerMonth = 0;
    var outMobilitaetSonstigePerMonthNew = 0;
    if(document.getElementById("out_mobi_sonstige").value != ""){
        outMobilitaetSonstige = document.getElementById("out_mobi_sonstige").value;
        outMobilitaetSonstige =  parseInt(outMobilitaetSonstige.replace(".",""));
        if(document.body.contains(document.getElementById("out_mobilitaet_slider")) && document.getElementById("out_mobilitaet_slider").value > 0){
            document.getElementById("out_mobi_sonstige_new").style.display = 'block';
            var sliderValue = document.getElementById("out_mobilitaet_slider").value;
            outMobilitaetSonstigeNew = parseInt(outMobilitaetSonstige + (sliderValue * outMobilitaetSonstige/100));
            outNewStatus = 1;
        } else document.getElementById("out_mobi_sonstige_new").style.display = 'none';
        var outMobilitaetSonstigeSelect = parseInt(document.getElementById("out_mobi_sonstige_select").value);
        outMobilitaetSonstigePerMonth = parseInt(outMobilitaetSonstige/outMobilitaetSonstigeSelect);
        outMobilitaetSonstigePerMonthNew = parseInt(outMobilitaetSonstigeNew/outMobilitaetSonstigeSelect);
        document.getElementById("out_mobi_sonstige_new").innerHTML = (outMobilitaetSonstigeNew).formatMoney(2, ',', '.');
        if(outMobilitaetSonstigePerMonthNew == 0) outMobilitaetSonstigePerMonthNew = outMobilitaetSonstigePerMonth; 
    } 


    //--Freizeit: Sport-------*/
    var outSportWellness = 0;
    var outSportWellnessNew = 0;
    var outSportWellnessPerMonth = 0;
    var outSportWellnessPerMonthNew = 0;
    if(document.getElementById("out_freizeit_sport").value != ""){
        outSportWellness = document.getElementById("out_freizeit_sport").value;
        outSportWellness =  parseInt(outSportWellness.replace(".",""));
        if(document.body.contains(document.getElementById("out_freizeit_slider")) && document.getElementById("out_freizeit_slider").value > 0){
            document.getElementById("out_freizeit_sport_new").style.display = 'block';
            var sliderValue = document.getElementById("out_freizeit_slider").value;
            outSportWellnessNew = parseInt(outSportWellness + (sliderValue * outSportWellness/100));
            outNewStatus = 1;
        } else document.getElementById("out_freizeit_sport_new").style.display = 'none';
        var outSportWellnessSelect = parseInt(document.getElementById("out_freizeit_sport_select").value);
        outSportWellnessPerMonth = parseInt(outSportWellness/outSportWellnessSelect);
        outSportWellnessPerMonthNew = parseInt(outSportWellnessNew/outSportWellnessSelect);
        document.getElementById("out_freizeit_sport_new").innerHTML = (outSportWellnessNew).formatMoney(2, ',', '.');
        if(outSportWellnessPerMonthNew == 0) outSportWellnessPerMonthNew = outSportWellnessPerMonth; 
    } 
     //--Freizeit: Ausgehen-------*/
     var outAusgehen = 0;
     var outAusgehenNew = 0;
     var outAusgehenPerMonth = 0;
     var outAusgehenPerMonthNew = 0;
     if(document.getElementById("out_freizeit_ausgehen").value != ""){
         outAusgehen = document.getElementById("out_freizeit_ausgehen").value;
         outAusgehen =  parseInt(outAusgehen.replace(".",""));
         if(document.body.contains(document.getElementById("out_freizeit_slider")) && document.getElementById("out_freizeit_slider").value > 0){
             document.getElementById("out_freizeit_ausgehen_new").style.display = 'block';
             var sliderValue = document.getElementById("out_freizeit_slider").value;
             outAusgehenNew = parseInt(outAusgehen + (sliderValue * outAusgehen/100));
             outNewStatus = 1;
         } else document.getElementById("out_freizeit_ausgehen_new").style.display = 'none';
         var outAusgehenSelect = parseInt(document.getElementById("out_freizeit_ausgehen_select").value);
         outAusgehenPerMonth = parseInt(outAusgehen/outAusgehenSelect);
         outAusgehenPerMonthNew = parseInt(outAusgehenNew/outAusgehenSelect);
         document.getElementById("out_freizeit_ausgehen_new").innerHTML = (outAusgehenNew).formatMoney(2, ',', '.');
         if(outAusgehenPerMonthNew == 0) outAusgehenPerMonthNew = outAusgehenPerMonth; 
     } 
      //--Freizeit: Urlaub-------*/
    var outUrlaub = 0;
    var outUrlaubNew = 0;
    var outUrlaubPerMonth = 0;
    var outUrlaubPerMonthNew = 0;
    if(document.getElementById("out_freizeit_urlaub").value != ""){
        outUrlaub = document.getElementById("out_freizeit_urlaub").value;
        outUrlaub =  parseInt(outUrlaub.replace(".",""));
        if(document.body.contains(document.getElementById("out_freizeit_slider")) && document.getElementById("out_freizeit_slider").value > 0){
            document.getElementById("out_freizeit_urlaub_new").style.display = 'block';
            var sliderValue = document.getElementById("out_freizeit_slider").value;
            outUrlaubNew = parseInt(outUrlaub + (sliderValue * outUrlaub/100));
            outNewStatus = 1;
        } else document.getElementById("out_freizeit_urlaub_new").style.display = 'none';
        var outUrlaubSelect = parseInt(document.getElementById("out_freizeit_urlaub_select").value);
        outUrlaubPerMonth = parseInt(outUrlaub/outUrlaubSelect);
        outUrlaubPerMonthNew = parseInt(outUrlaubNew/outUrlaubSelect);
        document.getElementById("out_freizeit_urlaub_new").innerHTML = (outUrlaubNew).formatMoney(2, ',', '.');
        if(outUrlaubPerMonthNew == 0) outUrlaubPerMonthNew = outUrlaubPerMonth; 
    } 
     //--Freizeit: Sonstige-------*/
     var outFreizeitSonstige = 0;
     var outFreizeitSonstigeNew = 0;
     var outFreizeitSonstigePerMonth = 0;
     var outFreizeitSonstigePerMonthNew = 0;
     if(document.getElementById("out_freizeit_sonstige").value != ""){
         outFreizeitSonstige = document.getElementById("out_freizeit_sonstige").value;
         outFreizeitSonstige =  parseInt(outFreizeitSonstige.replace(".",""));
         if(document.body.contains(document.getElementById("out_freizeit_slider")) && document.getElementById("out_freizeit_slider").value > 0){
             document.getElementById("out_freizeit_sonstige_new").style.display = 'block';
             var sliderValue = document.getElementById("out_freizeit_slider").value;
             outFreizeitSonstigeNew = parseInt(outFreizeitSonstige + (sliderValue * outFreizeitSonstige/100));
             outNewStatus = 1;
         } else document.getElementById("out_freizeit_sonstige_new").style.display = 'none';
         var outFreizeitSonstigeSelect = parseInt(document.getElementById("out_freizeit_sonstige_select").value);
         outFreizeitSonstigePerMonth = parseInt(outFreizeitSonstige/outFreizeitSonstigeSelect);
         outFreizeitSonstigePerMonthNew = parseInt(outFreizeitSonstigeNew/outFreizeitSonstigeSelect);
         document.getElementById("out_freizeit_sonstige_new").innerHTML = (outFreizeitSonstigeNew).formatMoney(2, ',', '.');
         if(outFreizeitSonstigePerMonthNew == 0) outFreizeitSonstigePerMonthNew = outFreizeitSonstigePerMonth; 
     } 


     //--Sonstige: Ausbildung-------*/
     var outSonstigeAusbildung = 0;
     var outSonstigeAusbildungNew = 0;
     var outSonstigeAusbildungPerMonth = 0;
     var outSonstigeAusbildungPerMonthNew = 0;
     if(document.getElementById("out_sonstige_ausbildung").value != ""){
         outSonstigeAusbildung = document.getElementById("out_sonstige_ausbildung").value;
         outSonstigeAusbildung =  parseInt(outSonstigeAusbildung.replace(".",""));
         if(document.body.contains(document.getElementById("out_sonstige_slider")) && document.getElementById("out_sonstige_slider").value > 0){
             document.getElementById("out_sonstige_ausbildung_new").style.display = 'block';
             var sliderValue = document.getElementById("out_sonstige_slider").value;
             outSonstigeAusbildungNew = parseInt(outSonstigeAusbildung + (sliderValue * outSonstigeAusbildung/100));
             outNewStatus = 1;
         } else document.getElementById("out_sonstige_ausbildung_new").style.display = 'none';
         var outSonstigeAusbildungSelect = parseInt(document.getElementById("out_sonstige_ausbildung_select").value);
         outSonstigeAusbildungPerMonth = parseInt(outSonstigeAusbildung/outSonstigeAusbildungSelect);
         outSonstigeAusbildungPerMonthNew = parseInt(outSonstigeAusbildungNew/outSonstigeAusbildungSelect);
         document.getElementById("out_sonstige_ausbildung_new").innerHTML = (outSonstigeAusbildungNew).formatMoney(2, ',', '.');
         if(outSonstigeAusbildungPerMonthNew == 0) outSonstigeAusbildungPerMonthNew = outSonstigeAusbildungPerMonth; 
     } 
     //--Sonstige: Kinder-------*/
     var outSonstigeKinder = 0;
     var outSonstigeKinderNew = 0;
     var outSonstigeKinderPerMonth = 0;
     var outSonstigeKinderPerMonthNew = 0;
     if(document.getElementById("out_sonstige_kinder").value != ""){
         outSonstigeKinder = document.getElementById("out_sonstige_kinder").value;
         outSonstigeKinder =  parseInt(outSonstigeKinder.replace(".",""));
         if(document.body.contains(document.getElementById("out_sonstige_slider")) && document.getElementById("out_sonstige_slider").value > 0){
             document.getElementById("out_sonstige_kinder_new").style.display = 'block';
             var sliderValue = document.getElementById("out_sonstige_slider").value;
             outSonstigeKinderNew = parseInt(outSonstigeKinder + (sliderValue * outSonstigeKinder/100));
             outNewStatus = 1;
         } else document.getElementById("out_sonstige_kinder_new").style.display = 'none';
         var outSonstigeKinderSelect = parseInt(document.getElementById("out_sonstige_kinder_select").value);
         outSonstigeKinderPerMonth = parseInt(outSonstigeKinder/outSonstigeKinderSelect);
         outSonstigeKinderPerMonthNew = parseInt(outSonstigeKinderNew/outSonstigeKinderSelect);
         document.getElementById("out_sonstige_kinder_new").innerHTML = (outSonstigeKinderNew).formatMoney(2, ',', '.');
         if(outSonstigeKinderPerMonthNew == 0) outSonstigeKinderPerMonthNew = outSonstigeKinderPerMonth; 
     } 
     //--Sonstige: Sonstige-------*/
     var outSonstigeSonstige = 0;
     var outSonstigeSonstigeNew = 0;
     var outSonstigeSonstigePerMonth = 0;
     var outSonstigeSonstigePerMonthNew = 0;
     if(document.getElementById("out_sonstige_sonstige").value != ""){
         outSonstigeSonstige = document.getElementById("out_sonstige_sonstige").value;
         outSonstigeSonstige =  parseInt(outSonstigeSonstige.replace(".",""));
         if(document.body.contains(document.getElementById("out_sonstige_slider")) && document.getElementById("out_sonstige_slider").value > 0){
             document.getElementById("out_sonstige_sonstige_new").style.display = 'block';
             var sliderValue = document.getElementById("out_sonstige_slider").value;
             outSonstigeSonstigeNew = parseInt(outSonstigeSonstige + (sliderValue * outSonstigeSonstige/100));
             outNewStatus = 1;
         } else document.getElementById("out_sonstige_sonstige_new").style.display = 'none';
         var outSonstigeSonstigeSelect = parseInt(document.getElementById("out_sonstige_sonstige_select").value);
         outSonstigeSonstigePerMonth = parseInt(outSonstigeSonstige/outSonstigeSonstigeSelect);
         outSonstigeSonstigePerMonthNew = parseInt(outSonstigeSonstigeNew/outSonstigeSonstigeSelect);
         document.getElementById("out_sonstige_sonstige_new").innerHTML = (outSonstigeSonstigeNew).formatMoney(2, ',', '.');
         if(outSonstigeSonstigePerMonthNew == 0) outSonstigeSonstigePerMonthNew = outSonstigeSonstigePerMonth; 
     } 


    
    //Count all items / Add more items with +
    allOut = outMietePerMonth + outWohnenSonstigePerMonth + outStromPerMonth + outWaermePerMonth + outEinkaufPerMonth + outKleidungPerMonth + outInternetTelePerMonth + outMedienStreamingPerMonth + outGesundheitPerMonth + outVersicherungenPerMonth + outFahrzeugePerMonth + outOpnvPerMonth + outMobilitaetSonstigePerMonth+ outSportWellnessPerMonth + outAusgehenPerMonth + outUrlaubPerMonth + outFreizeitSonstigePerMonthNew+ outSonstigeAusbildungPerMonth + outSonstigeKinderPerMonth + outSonstigeSonstigePerMonth;
    allOutNew = outMietePerMonthNew + outWohnenSonstigePerMonthNew + outStromPerMonthNew + outWaermePerMonthNew + outEinkaufPerMonthNew + outKleidungPerMonthNew + outInternetTelePerMonthNew + outMedienStreamingPerMonthNew + outGesundheitPerMonthNew + outVersicherungenPerMonthNew + outFahrzeugePerMonthNew + outOpnvPerMonthNew + outMobilitaetSonstigePerMonthNew+ outSportWellnessPerMonthNew + outAusgehenPerMonthNew + outUrlaubPerMonthNew + outFreizeitSonstigePerMonthNew+ outSonstigeAusbildungPerMonthNew + outSonstigeKinderPerMonthNew + outSonstigeSonstigePerMonthNew;

     //All Results
    //console.log("Result: New: " + allOutNew + " Old: " + allOut)
    document.getElementById("out_einnahmen").value = (allIn).formatMoney(2, ',', '.');
    document.getElementById("out_ausgaben").value = (allOut).formatMoney(2, ',', '.');
    if(outNewStatus == 1) {
        document.getElementById("out_ausgaben_neu").value = (allOutNew).formatMoney(2, ',', '.');
        document.getElementById("out_ausgaben_neu_div").style.display = 'block';
    } else document.getElementById("out_ausgaben_neu_div").style.display = 'none';

    //Ergebnisfelder anzeigen, färben und Text ausgeben
    if(allIn <= allOut) {
        document.getElementById("out_ausgaben").parentNode.setAttribute("class", "form-field-input state-false");
        document.getElementById("ergebnis_text_rot").style.display = 'block';
        document.getElementById("ergebnis_text_gruen").style.display = 'none';
    } else { 
        console.log("grün");
        document.getElementById("out_ausgaben").parentNode.setAttribute("class", "form-field-input state-true"); 
        document.getElementById("ergebnis_text_rot").style.display = 'none';
        document.getElementById("ergebnis_text_gruen").style.display = 'block';
    }
    if(allIn <= allOutNew){
        document.getElementById("out_ausgaben_neu").parentNode.setAttribute("class", "form-field-input state-false"); 
        document.getElementById("ergebnis_text_rot").style.display = 'block';
        document.getElementById("ergebnis_text_gruen").style.display = 'none';
    } else {
        document.getElementById("out_ausgaben_neu").parentNode.setAttribute("class", "form-field-input state-true"); 
        document.getElementById("ergebnis_text_rot").style.display = 'none';
        document.getElementById("ergebnis_text_gruen").style.display = 'block';
    }
};
/**
 * Input text Listener
 */
let allInputs = document.querySelectorAll('input[type=text]');
for (var i = 0; i < allInputs.length; i++) {
    allInputs[i].addEventListener("focus", function() {
        this.value = "";//clean on focus
        //console.log("focus! " + this.readonly);
    });
    allInputs[i].addEventListener("keyup", function() {
        if (isNaN(this.value)) this.value = ""; //Numbers only
        this.value = this.value.replace(".","");//Delete Points
        //console.log("key up! ");
        calculate();
    });
    allInputs[i].addEventListener("blur", function() {
        var tmpValue = parseInt(this.value);
        document.getElementById(this.id).value = (tmpValue).formatMoney(2, ',', '.');
        //console.log("blur! ");
    });
};
/**
 * Input select
 */
onSelectOption = function(element) {
    // Set selected option value to hidden select input value
    const hiddenSelectInput = element.parentNode.parentNode.querySelector('.input-select-value');
    hiddenSelectInput.value = element.getAttribute('data-value');

    // Set active state to selected option
    const selectOptions = element.parentNode.querySelectorAll('.input-select-option-item');
    selectOptions.forEach(option => {
        option.classList.remove("selected");
    })
    element.classList.add("selected");

    // Close select options after selecting
    element.parentNode.parentNode.querySelector('.input-select').checked = false;

    // Show selected option on input field
    const selectInputLabel = element.parentNode.parentNode.querySelector('.input-select-label');
    const selectInputLabelValue = selectInputLabel.querySelector('.input-select-label-value');
    selectInputLabelValue.innerHTML = element.innerHTML;
    selectInputLabel.classList.add("selected");

    calculate();
}


/**
 * preselection Input select
 */
 const preSelections = document.querySelectorAll('.input-select-option')

 if(preSelections) {
    preSelections.forEach(preSelection => {
        const preOptions = preSelection.querySelectorAll('.input-select-option-item');
    
        preOptions.forEach(preOption => {
            if (preSelection.dataset.value === preOption.dataset.value) {
                setTimeout(() => {
                    const preLabel = preSelection.parentNode.parentNode.querySelector('.input-select-label');
                    const preValue = preLabel.querySelector('.input-select-label-value');
                    preValue.innerHTML = preOption.innerText;
                    preOption.classList.add("selected");
                    preLabel.classList.add("selected");
                }, 100);
      
            } else {
                return;
            }
        })
    });
 }
 

/**
 * Range Slider
 */

// Add scale for all range sliders with class scale
let rangeSliderElements = document.querySelectorAll(".range-slider");
rangeSliderElements.forEach(element => {
    if (element.classList.contains('scale')) {
        const rangeSlider = element.querySelector('.range-slider-input')
        const maxValue = rangeSlider.getAttribute("max")
        const stepValue = rangeSlider.getAttribute("step")

        if (maxValue % stepValue === 0) {
            const scale = document.createElement('div');
            scale.classList.add('range-slider-scale');

            let strokes = document.createDocumentFragment();
            const numberOfStrokes = (maxValue / stepValue) + 1

            for(let x = 0; x < numberOfStrokes; x++) {
                const scaleStroke = document.createElement('div');
                scaleStroke.classList.add('range-slider-scale-stroke');
                strokes.appendChild(scaleStroke);
            }

            scale.appendChild(strokes);

            const target = element.querySelector('.range-slider-progress');
            target.parentNode.insertBefore(scale, target.nextSibling);
        } else {
            console.error('Skala kann nicht generiert werden, da step size kein Vielfaches von max value ist.')
        }
    }
});

onChangeRangeSlide = function onChangeRangeSlide (element){
    // Show range slider value
    const prevElement = element.parentNode.previousElementSibling

    console.log(element);
    console.log(prevElement);

    if (prevElement.classList.contains('range-slider-value')) {
        prevElement.firstElementChild.innerHTML = element.value
    } else {
        prevElement.previousElementSibling.firstElementChild.innerHTML = element.value
    }

    // Adjust range slider progress bar according to input value
    const maxValue = element.getAttribute("max")
    const currentValue = element.value

    element.nextElementSibling.style.width = (currentValue * 100) / maxValue + "%";
    //if(currentValue > 0) calculate();
    calculate();
};

/*
if(parent.frames.length > 0) {
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    var body = document.body,
    html = document.documentElement;
    var thisSiteHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

    var id, eventSource, eventOrigin;

    eventer(messageEvent, function(event) {
      eventSource = event.source;
      eventOrigin = event.origin;

      var data = event.data;
      if(!data || data.length === 0) {
        return;
      }

      data = data.split('-');
      if(data.length !== 2) {
        return;
      }

      if(data[0] !== 'height') {
        return;
      }

      id = parseInt(data[1], 10);
      if(isNaN(id)) {
        return;
      }
      eventSource.postMessage(id + '-' + thisSiteHeight + '-' + 0, eventOrigin);

      function resize() {
        if(window.self != window.top) {
          var body = document.body,
          html = document.documentElement;
          var thisSiteHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
          setTimeout(function(){  eventSource.postMessage(id + '-' + thisSiteHeight + '-' + 0, eventOrigin); }, 500);
          console.log("test: " + thisSiteHeight)
        }
      }
      function resize_plus() {
        if(window.self != window.top) {
          var body = document.body,
          html = document.documentElement;
          var thisSiteHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight ) + 70;
          setTimeout(function(){  eventSource.postMessage(id + '-' + thisSiteHeight + '-' + 0, eventOrigin); }, 200);
        }
      }
  
      onresize = (event) => {
        resize();
        console.log("onresize");
      };
      
      document.addEventListener("DOMContentLoaded", () => {
        resize();
        console.log("ready");
      });

    }, false);
}
*/